import React, { useState, useEffect } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import businessUnitCompletionsService from '../charts/business_unit_completions.service';
const BusinessUnitCompletionTable = _ref => {
  let {
    filteredBusinessUnits,
    selectedYears,
    selectedSubsidiaryCompanyIds,
    companyId
  } = _ref;
  const {
    t
  } = useTranslation();
  const grey = '#666E7E';
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const businessUnitsParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
        const yearsParam = selectedYears.join(',');
        const subsidiaryCompanyIdsParam = selectedSubsidiaryCompanyIds.join(',');
        const data = await businessUnitCompletionsService.all(companyId, businessUnitsParam, yearsParam, subsidiaryCompanyIdsParam);
        setChartData(data);
      } catch (error) {
        console.error('Error fetching Business Unit Completion data:', error);
      }
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedYears, selectedSubsidiaryCompanyIds]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-business-unit-table-container",
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    style: {
      borderCollapse: 'separate',
      borderSpacing: '0 8px'
    }
  }, /*#__PURE__*/React.createElement("thead", {
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement("th", null, t('Unit')), /*#__PURE__*/React.createElement("th", null, t('Project Completion')), /*#__PURE__*/React.createElement("th", null, t('Cost Completion')))), /*#__PURE__*/React.createElement("tbody", {
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, chartData.map(item => /*#__PURE__*/React.createElement("tr", {
    key: item.business_unit_name,
    style: {
      backgroundColor: '#F5FAFD'
    }
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    }
  }, item.business_unit_name), /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    }
  }, item.completion_percentage, /*#__PURE__*/React.createElement("span", null, "%")), /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    }
  }, item.positive_cost_percentage, /*#__PURE__*/React.createElement("span", null, "%")))), chartData.length === 0 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#F5FAFD',
      border: '2px solid white'
    },
    colSpan: 3,
    className: "text-center"
  }, t('No data'))))));
};
export default BusinessUnitCompletionTable;